import * as React from "react";
import { forwardRef } from "react";
const SvgEmptyLocationFlag = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 22, height: 14, viewBox: "0 0 22 14", fill: "none", id: "svg4", xmlSpace: "preserve", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("rect", { width: 22, height: 14, rx: 2, fill: "#EEF0F2", id: "rect2" }), /* @__PURE__ */ React.createElement("g", { style: {
  fill: "none",
  stroke: "#737373",
  strokeOpacity: 1
}, id: "g1182", transform: "matrix(0.40585618,0,0,0.42805531,6.1297545,1.8653969)" }, /* @__PURE__ */ React.createElement("path", { d: "m 9.25,11 h 5.5", stroke: "#292d32", strokeWidth: 1.5, strokeLinecap: "round", id: "path1170", style: {
  stroke: "#737373",
  strokeOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M 3.61995,8.49 C 5.58995,-0.169998 18.42,-0.159997 20.38,8.5 c 1.15,5.08 -2.01,9.38 -4.78,12.04 -2.01,1.94 -5.19,1.94 -7.21005,0 -2.76,-2.66 -5.92,-6.97 -4.77,-12.05 z", stroke: "#292d32", strokeWidth: 1.5, id: "path1172", style: {
  stroke: "#737373",
  strokeOpacity: 1
} })));
const ForwardRef = forwardRef(SvgEmptyLocationFlag);
export { ForwardRef as ReactComponent };
